import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {Router} from "@angular/router";

@Component({
  selector: 'city-tax-landing-business',
  templateUrl: './landing-business.component.html',
  styleUrls: ['./landing-business.component.scss']
})
export class LandingBusinessComponent implements OnInit {
  @Input() public config$: any;

  public hasBusiness$ = new BehaviorSubject(false);

  public filing$ = new BehaviorSubject(false);
  public withholdings$ = new BehaviorSubject(false);
  public payments$ = new BehaviorSubject(false);

  constructor(private cd: ChangeDetectorRef,
              private router: Router) {
  }

  ngOnInit(): void {
    this.config$?.subscribe((config: any) => {
      if (config) {
        const components = config?.components || {};
        const business = components?.business || {};

        const hasBusiness = business.payments || business.estimates || business.withholdings || business.fillToFile || business.uploadToFile || business.scanToFile;
        this.hasBusiness$.next(hasBusiness);

        const withholdings = business.withholdings;
        this.withholdings$.next(withholdings);

        const filing = business.fillToFile || business.uploadToFile || business.scanToFile;
        this.filing$.next(filing);

        const payments = business.payments || business.estimates;
        this.payments$.next(payments);
      }
    });
  }


  onRedirect(path: string): void {
    this.router.navigate(['/auth/business'], {queryParams: {redirectPath: path}});
  }

}
